import { Component } from '@angular/core'

@Component({
  selector: 'app-legend',
  templateUrl: './legend-base.component.html',
  styleUrl: './legend-base.component.scss',
  standalone: false,
})
export class LegendComponent {}
